/* ==========================================================================
   Future Aesthetics — image lightbox
   Opens a full-screen overlay for size charts, washing guides, and any
   other images triggered via data-lightbox-src or data-lightbox-btn.
   ========================================================================== */

(function () {
  'use strict';

  const OVERLAY_CLASS = 'fa-lightbox';
  const OPEN_CLASS = 'is-open';

  /* ---- Create / cache the overlay DOM ---- */
  function getOverlay() {
    let overlay = document.querySelector('.' + OVERLAY_CLASS);
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = OVERLAY_CLASS;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Image preview');
    overlay.innerHTML = `
      <div class="${OVERLAY_CLASS}__backdrop" data-lightbox-close></div>
      <div class="${OVERLAY_CLASS}__inner">
        <button type="button" class="${OVERLAY_CLASS}__close" data-lightbox-close aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
        <img class="${OVERLAY_CLASS}__img" src="" alt="">
      </div>
    `;
    document.body.appendChild(overlay);

    // Close handlers
    overlay.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains(OPEN_CLASS)) {
        close();
      }
    });

    return overlay;
  }

  function open(src, alt) {
    const overlay = getOverlay();
    const img = overlay.querySelector('.' + OVERLAY_CLASS + '__img');
    img.src = src;
    img.alt = alt || '';
    overlay.classList.add(OPEN_CLASS);
    document.body.style.overflow = 'hidden';
  }

  function close() {
    const overlay = document.querySelector('.' + OVERLAY_CLASS);
    if (!overlay) return;
    overlay.classList.remove(OPEN_CLASS);
    overlay.querySelector('.' + OVERLAY_CLASS + '__img').src = '';
    document.body.style.overflow = '';
  }

  /* ---- Delegate click events ---- */
  document.addEventListener('click', function (e) {
    // Elements with data-lightbox-src open directly
    const trigger = e.target.closest('[data-lightbox-src]');
    if (trigger) {
      e.preventDefault();
      open(trigger.getAttribute('data-lightbox-src'), trigger.getAttribute('data-lightbox-alt') || '');
      return;
    }

    // Elements with data-lightbox-btn toggle a sibling / child image
    const btn = e.target.closest('[data-lightbox-btn]');
    if (btn) {
      e.preventDefault();
      const targetId = btn.getAttribute('data-lightbox-btn');
      let targetEl = null;
      if (targetId) {
        targetEl = document.querySelector(targetId);
      }
      if (!targetEl) {
        targetEl = btn.parentElement.querySelector('img');
      }
      if (targetEl) {
        open(targetEl.src || targetEl.getAttribute('data-full') || targetEl.getAttribute('src'), targetEl.alt || '');
      }
      return;
    }
  });

  /* Expose for other scripts */
  window.FaLightbox = { open: open, close: close };
})();
